import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { mapAcad021Categories, mapSoftwareFiltersWithAll } from 'academy-common-lib/constants/TopFilterConstants';
import CatalogDropdownMenu from './CatalogDropdownMenu';
import MobileCatalogMenu from './MobileCatalogMenu';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useImmutableFilters } from '../../features/filters/filtersQueries';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const DropdownButton = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    use: "link",
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-on-fill-default",
      typography: "heading-50",
      children: children
    })
  }));
};
const CatalogDropdownContainer = ({
  inlineLink,
  selectedGroup,
  selectedFilterType,
  buttonText,
  onOptionClick: onClickOption,
  buttonSize = 'default'
}) => {
  const {
    filtersLoading,
    filters
  } = useImmutableFilters();
  const {
    isMobile
  } = useMediaQuery();
  return !filtersLoading && (isMobile ? /*#__PURE__*/_jsx(MobileCatalogMenu, {
    buttonText: buttonText,
    categories: mapAcad021Categories(filters.subCategories),
    hsSoftwareCategories: mapSoftwareFiltersWithAll(filters.hsSoftwareFilters),
    inlineLink: inlineLink,
    onClickOption: onClickOption,
    selectedFilterType: selectedFilterType,
    selectedGroup: selectedGroup
  }) : /*#__PURE__*/_jsx(CatalogDropdownMenu, {
    Button: inlineLink ? DropdownButton : undefined,
    buttonStyles: buttonSize === 'large' ? {
      height: 58
    } : undefined,
    buttonText: buttonText,
    buttonUse: inlineLink ? 'link-on-dark' : 'tertiary-light',
    categories: mapAcad021Categories(filters.subCategories),
    hsSoftwareCategories: mapSoftwareFiltersWithAll(filters.hsSoftwareFilters),
    onClickOption: onClickOption
  }));
};
export default CatalogDropdownContainer;